export const ntQuotesData = [];
